import IconHover from 'components/icon-hover/icon-hover';
import styled from 'styled-components';

export const StyledTrashIconHover = styled(IconHover)`
  margin-left: 10px;
`;
